// extracted by mini-css-extract-plugin
export default {"cls1":"Banner-cls1_NTa","cls2":"Banner-cls2_ndF Banner-cls1_NTa"};